import { combineReducers } from "redux";
import searchReducer from "./searchSlice";
import filteredSearchReducer from "./filteredSearchSlice";
import documentMetaReducer from "./documentMetaSlice";
import mergeExportReducer from "./mergeExportSlice";
import documentListSlice from "./documentListSlice";
import filteredListSlice from "./filteredListSlice";
import ifsLatestSlice from "./ifsLatestSlice";
import documentSearchSlice from "./documentSearchSlice";
import deleteWorkingDocumentReducer from "./deleteWorkingDocumentSlice";
import documentRevisionInfoReducer from "./documentRevisionInfoSlice";
import checkinExistingFlowReducer from "./checkinExistingFlowSlice";

const documentsReducer = combineReducers({
  search: searchReducer,
  filteredSearch: filteredSearchReducer,
  meta: documentMetaReducer,
  mergeExport: mergeExportReducer,
  deleteWorkingDocument: deleteWorkingDocumentReducer,
  documentRevisionInfo: documentRevisionInfoReducer,
  checkinExistingFlow: checkinExistingFlowReducer,
});

export default documentsReducer;

export const documentListReducer = documentListSlice.reducer;
export const filteredListReducer = filteredListSlice.reducer;
export const ifsLatestReducer = ifsLatestSlice.reducer;
export const documentSearchReducer = documentSearchSlice.reducer;
export { default as documentUrlReducer } from "./documentUrlSlice";
export { default as documentDetailsReducer } from "./documentDetailsSlice";
export { default as previewInTeamsReducer } from "./previewInTeamsSlice";
export { default as uploadToOneDriveReducer } from "./uploadToOneDriveSlice";
export { default as documentCheckoutFlowReducer } from "./documentCheckoutFlowSlice";
